(function () {
    angular.module('MktzapApp.Controllers')
      .controller('VersioningController', VersioningController)
  
    VersioningController.$inject = ['NotificationService', 'VersioningService', 'FoundationApi', 'taOptions', 'textAngularManager', 'LangService']
  
    function VersioningController (NotificationService, VersioningService, FoundationApi, taOptions, textAngularManager, LangService) {
      var vm = this

      taOptions.toolbar = [
        ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote', 'bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol',
          'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent',
          'html', 'insertLink']
      ];

      LangService
        .getPageLabels({ 'page': 'menu.master.versioning' })
        .$promise
        .then(function (data) {
          vm.labels = data.lang
        })

        loadVersioning() 

        function loadVersioning () {
          VersioningService
          .all()
          .$promise
          .then(function (data) {
            vm.versioningData = data;
          })
          .catch(function (error) {
            NotificationService.errorHandler(error, vm.labels.errorToLoadVersioningData)
          })
        }

        vm.versioningModal = function () {
          vm.versioning = cleanFields();
          FoundationApi.publish('versioningModal', 'open')
        }

        
        vm.editVersioning = function (receiveVersioning) {
          vm.versioning = receiveVersioning;
          FoundationApi.publish('versioningModal', 'open')
        } 

        vm.saveVersioning = function() { 
          
          if (!vm.versioning.title || !vm.versioning.description) {
            NotificationService.warningHandler(null, vm.labels.fillObligatedFields)
            return;
          }

          getStorageRequest()
            .$promise
            .then(function(data){
              NotificationService.successHandler(null, vm.labels.requestProcessed)
              loadVersioning();
            }).catch(function (error) {
              NotificationService.errorHandler(null, vm.labels.requestError)
            })

            FoundationApi.publish('versioningModal', 'close')

        }
        
        vm.deleteVersioningModal = function (receiveVersioning, index) {
          vm.versioning = receiveVersioning
          vm.index = index
          FoundationApi.publish('deleteVersioningModal', 'open')
        }
        
        vm.deleteVersioning = function (versioning, index) {
          VersioningService
            .delete({
              id: versioning.id
            })
            .$promise
            .then(function (data) {
              vm.versioningData.splice(index, 1)
              NotificationService.successHandler(null, vm.labels.versioningDeleted)
            })
            .catch(function (data) {
              NotificationService.successHandler(null, vm.labels.requestError)
            })
    
          FoundationApi.publish('deleteVersioningModal', 'close')
        }

        function cleanFields() {
          vm.versioning = {
            title: '',
            description: '',
          }
        }

        function getStorageRequest () {
          if (typeof vm.versioning.id !== 'undefined') {
            return VersioningService.update(vm.versioning)
          }
    
          return VersioningService.save(vm.versioning)
        }
    
    }
   
})();